import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'normalize.css'
import GifExpertApp from './GifExpertApp'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GifExpertApp/>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

